import { useTenantAreas } from '../../../lib/access/useTenantAreas';
/**
 * SAD-948: uploading a sheet feeds the shared rate book, so it is offered
 * only to area:registries holders — and admins/internal.
 *
 * SAD-1210: the one place this is decided; every pricing-sheet upload entry
 * point asks here rather than restating the predicate.
 */ export function useCanUploadPricingSheet() {
    const areas = useTenantAreas();
    return areas.registries || areas.isAdmin || areas.isInternal;
}
